@if (row() && row()!.generalRate === true) {
  <span class="text-nowrap">{{ 'portfolio.generalRates' | translate }}</span>
} @else if (row() && row()!.generalRate === false) {
  <span class="text-nowrap">{{ 'portfolio.specificAdvice' | translate }}</span>
} @else {
  <span>-</span>
}
